import _findIndex from 'lodash/findIndex'

export const shouldGoToNextQuestion = ({ isAllowanceUpdate }) => !isAllowanceUpdate

export const shouldGoToNextAllowanceQuestion = ({ isAllowanceUpdate, shouldGoToNextAllowanceQuestion }) => {
    if (!isAllowanceUpdate) return false
    return !!shouldGoToNextAllowanceQuestion
}

export const updateOrAddItemsById = ({ currentItems, receivedItems, idKey = 'id' }) => {
    const items = Object.assign([], currentItems)

    if (Array.isArray(receivedItems)) {
        receivedItems.forEach((item) => {
            const index = _findIndex(items, [idKey, item[idKey]])

            if (index > -1 && items[index]) {
                items[index] = item
            } else {
                items.push(item)
            }
        })
    }

    return items
}

export const removeItemsById = ({ currentItems, id, idKey = 'id' }) => {
    const items = Object.assign([], currentItems)

    if (id) {
        const index = items.findIndex((o) => o[idKey] === id)

        if (index > -1 && items[index]) {
            items.splice(index, 1)
        }
    }

    return items
}
